import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02281bde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "operation ws_mb16" }

import { ref, watch } from 'vue'
import { queryDevicePlaybackPage } from '@/api'
import { CODE_ENUM } from '@/common/enum'
import { get } from 'lodash'
import moment from 'moment'
import { exportDeviceTrail } from '@/api'
import { ElMessage } from 'element-plus'
import { downLoadFile } from '@/utils'
import { formatLat, formatLng } from '@/utils/map.utils'
import { isEmpty } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'trail-data',
  props: ['visible', 'data', 'getMap'],
  emits: ['update:visible'],
  setup(__props, { emit: __emit }) {

const $emit = __emit
const props = __props

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      fetchList()
    } else {
      total.value = 0
      pageParams.value.curPage = 1
    }
  }
)

const handleClose = () => {
  $emit('update:visible', false)
}

const col: any = [
  {
    label: '序号',
    width: 120,
    formatter: (row: any, column: any, cellValue: any, index: number) => {
      const { curPage } = pageParams.value
      return (curPage - 1) * 10 + index + 1
    },
  },
  {
    label: '经度/纬度',
    prop: 'deviceLocationInfo',
    formatter: (data: any) => {
      const latitude = get(data, 'deviceLocationInfo.latitude')
      const longitude = get(data, 'deviceLocationInfo.longitude')
      if (!latitude && !longitude) {
        return '-'
      }
      return [
        formatLng(longitude) + longitude,
        formatLat(latitude) + latitude,
      ].join(',')
    },
  },
  {
    label: '采集时间',
    prop: 'playBackSendTime',
    formatter: (data: any) => {
      return moment(data.playBackSendTime).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    label: '速度( Km/小时 )',
    prop: 'speed',
  },
]

const total = ref(0)
const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const handleCurrentChange = () => {
  fetchList()
}

const tableData: any = ref([])
const tableLoading = ref(false)

const getParams = () => {
  const { deviceId, time } = props.data
  const [start, end] = time || []
  return {
    deviceId,
    endTime: moment(end).valueOf(),
    startTime: moment(start).valueOf(),
  }
}

const fetchList = async () => {
  tableLoading.value = true
  const res: any = await queryDevicePlaybackPage({
    ...pageParams.value,
    ...getParams(),
  }).finally(() => {
    tableLoading.value = false
  })

  if (res?.code === CODE_ENUM.SUCCESS) {
    total.value = res?.data?.total || 0
    const records = res?.data?.records || []
    tableData.value = records.map((item: any, index: number) => {
      const speed = getSpeed(
        index - 1 >= 0 ? formatData(records[index - 1]) : {},
        formatData(records[index])
      )
      return {
        ...item,
        speed,
      }
    })
  }
}

const formatData = (data: any) => {
  const { playBackSendTime } = data
  const latitude = get(data, 'deviceLocationInfo.latitude')
  const longitude = get(data, 'deviceLocationInfo.longitude')
  return [latitude, longitude, playBackSendTime]
}

const exportData = async () => {
  const res = await exportDeviceTrail({
    ...pageParams.value,
    ...getParams(),
    curPage: 1,
  })
  if (res?.msg?.code === CODE_ENUM.SUCCESS) {
    downLoadFile(res)
  }
}

const getSpeed = (pre: any, now: any) => {
  const { getMap } = props
  const map = getMap()
  if (isEmpty(pre) || isEmpty(now)) {
    return ' - '
  }
  const [preLatitude = 0, preLongitude = 0, preUpdateTime = 0] = pre
  const [latitude = 0, longitude = 0, updateTime = 0] = now
  if (preLatitude === latitude && preLongitude === longitude) {
    return '0km/h'
  }
  if (preUpdateTime === updateTime) {
    return ' - '
  }
  const m = map.distance(
    { lat: preLatitude, lng: preLongitude },
    { lat: latitude, lng: longitude }
  )
  const km = m / 1000
  // console.log(km, 'kmkmkm')
  const t = updateTime - preUpdateTime

  const h = t / 3600000
  // console.log(updateTime, preUpdateTime, 'tttt')
  // console.log(
  //   moment(updateTime).format('YYYY-MM-DD HH:mm:ss'),
  //   moment(preUpdateTime).format('YYYY-MM-DD HH:mm:ss')
  // )
  // console.log(t, 'tttt')
  // console.log(h, 'hhhh')

  const s = (km / h).toFixed(2)
  if (isNaN(Number(s))) {
    return ' - '
  } else if (s === '0.00') {
    return '0km/h'
  }
  return s + 'km/h'
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: "轨迹详情",
    width: "920",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          disabled: tableData.value.length === 0,
          type: "primary",
          onClick: exportData
        }, {
          default: _withCtx(() => [
            _createTextVNode("导出excel")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        class: "ws_common_table ws_mb16",
        data: tableData.value,
        stripe: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
            return _createVNode(_component_el_table_column, _mergeProps({
          ...item,
        }, {
              key: index,
              "show-overflow-tooltip": ""
            }), null, 16)
          }), 64))
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        layout: "->, total,  prev, pager, next, jumper ",
        total: total.value,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})